import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { HELP } from '@app/src/common/constants/helpLinks';
import useHelpLink from '@app/src/common/hooks/useHelpLink';
import { Tooltip } from '@fw-nextgen/fw-components';
import HelpIcon from '@app/src/assets/help.svg';

import './HelpLink.scss';

interface IProps {
  className?: string;
}

const HelpLink = ({ className }: IProps) => {
  const { onLinkOpen, isLoading } = useHelpLink(HELP);

  return (
    <>
      <HelpIcon
        className={classNames('help-link', className)}
        onClick={isLoading ? undefined : onLinkOpen}
        data-tooltip-id="help-link"
      />

      <Tooltip id="help-link">
        <FormattedMessage id="toolbar.menu.item.help" />
      </Tooltip>
    </>
  );
};

export default HelpLink;
